import React from 'react';
import useTilt from '../hooks/useTilt';

export default function ProductItemCard({ product, navigateTo, setSelectedImage, idx }) {
  const { tilt, onMouseMove, onMouseLeave } = useTilt();
  const imageUrl = product.images?.[0]?.url || product.img;

  return (
    <div className={`animate-hidden animate-scale delay-${(idx % 3) * 100}`}>
      <div
        className="product-card stunner-card"
        onMouseMove={onMouseMove}
        onMouseLeave={onMouseLeave}
        style={{
          transform: `perspective(1200px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg) translateY(${tilt.x !== 0 ? -10 : 0}px)`,
          transition: tilt.x === 0 ? 'transform 0.6s ease' : 'none',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* Shine effect */}
        <div 
          className="card-shine"
          style={{
            background: `radial-gradient(circle at ${tilt.shine.x}% ${tilt.shine.y}%, rgba(255,255,255,0.15) 0%, transparent 80%)`
          }}
        />

        <div 
          className="product-image-container" 
          onClick={() => setSelectedImage(imageUrl)} 
          style={{ cursor: 'zoom-in', transformStyle: 'preserve-3d' }}
        >
          <img 
            src={imageUrl} 
            alt={product.name} 
            className="product-image" 
            onError={(e) => { e.target.src = 'https://via.placeholder.com/300?text=Image+Not+Found'; }}
            style={{
              transform: `translateZ(60px) scale(${tilt.x !== 0 ? 1.05 : 1})`,
              transition: tilt.x === 0 ? 'transform 0.6s ease' : 'none'
            }}
          />
        </div>

        <div 
          className="product-details" 
          style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            gap: '0.5rem',
            transform: `translateZ(40px)`,
            transformStyle: 'preserve-3d'
          }}
        >
          <h3 className="product-name" style={{ transform: 'translateZ(20px)' }}>{product.name}</h3>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.8rem', transform: 'translateZ(10px)' }}>{product.id || 'NDT-Tool'}</p>
          <div
            className="card-action"
            onClick={(e) => {
              e.stopPropagation();
              navigateTo('productDetails', product);
            }}
            style={{ cursor: 'pointer', transform: 'translateZ(30px)' }}
          >
            View Details <span className="arrow-icon">&#8594;</span>
          </div>
        </div>
      </div>
    </div>
  );
}
